import { ShamDashboardData } from 'sham-components/features/dashboard';
import {
  ShamCashbackIcon,
  ShamComplaintIcon,
  ShamCoupon02Icon,
  ShamDashboardSquare01StrokeIcon,
  ShamHouse02StrokeIcon,
  ShamInvoice03Icon,
  ShamPackageAddIcon,
  ShamPackageIcon,
  ShamPackagingStrokeIcon,
  ShamMoneyBag02Icon,
  ShamSettingError04Icon,
  ShamSettingsIcon,
  ShamStarIcon,
  ShamStarSellerIcon,
  ShamComplaintSellerIcon,
} from 'sham-components/icons';

export async function dashboardLayoutDataFactory(dashData: ShamDashboardData) {
  dashData.navLinks.set([
    {
      name: 'New Product',
      paths: 'products/new',
      icon: ShamPackageAddIcon,
    },
    'hr',
    {
      name: 'Dashboard',
      paths: 'dashboard',
      icon: ShamDashboardSquare01StrokeIcon,
    },
    {
      name: 'Products',
      paths: 'products',
      icon: ShamPackageIcon,
    },
    // {
    //   name: 'Store Overview',
    //   paths: 'overview',
    //   icon: ShamStore03StrokeIcon,
    // },
    {
      name: 'Orders',
      paths: 'orders',
      icon: ShamPackagingStrokeIcon,
    },
    {
      name: 'Payments',
      paths: 'payments',
      icon: ShamInvoice03Icon,
    },
    {
      name: 'Refunds',
      paths: 'refunds',
      icon: ShamCashbackIcon,
    },
    {
      name: 'Reviews',
      paths: 'reviews',
      icon: ShamStarSellerIcon,
    },
    {
      name: 'Reported Reviews',
      paths: 'reported-reviews',
      icon: ShamComplaintSellerIcon,
    },
    {
      name: 'Coupons',
      paths: 'coupons',
      icon: ShamCoupon02Icon,
    },
    {
      name: 'Warehouses',
      paths: 'warehouses',
      icon: ShamHouse02StrokeIcon,
    },
    {
      name: 'Accounting',
      paths: 'accounting',
      icon: ShamMoneyBag02Icon,
    },
    {
      name: 'General Settings',
      paths: 'general-settings',
      icon: ShamSettingsIcon,
    },
  ]);
}
